import {
  getItemFromCollection,
} from "directus/src/operations";
import client from "directus/src/client";
import { customEndpoint } from "directus/src/operations";

export async function fetchRepoForGithub({ id }) {
  try {
    const query = {
      fields: ["id", "repository_url", "suffix"],
    };
    const response = await getItemFromCollection("integrations_github", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function addEmployeeAccess({ repository_url, employees }) {
  try {
    const response = await client.request(
      customEndpoint({
        path: `/github/repository/add_access`,
        method: "POST",
        body: JSON.stringify({
          repository_url,
          employees,
        }),
      })
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function removeEmployeeAccess({ repository_url, employeeId }) {
  try {
    const query = new URLSearchParams({
      repository_url,
      employee: employeeId,
    }).toString();

    const response = await client.request(
      customEndpoint({
        path: `/github/repository/remove_access?${query}`,
        method: "DELETE",
      })
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
